import { VINICIUS_ADMIN_EMAIL } from '../utils';

/**
 * Premissa de desenvolvimento: o e-mail `vinicius_admin` tem acesso a qualquer
 * module configuration (único dev / superusuário operacional no front).
 */
export function isViniciusAdmin(authDataOrEmail) {
  const email = typeof authDataOrEmail === 'string' ? authDataOrEmail : authDataOrEmail?.email;
  return email === VINICIUS_ADMIN_EMAIL;
}

/**
 * Verifica se o usuário tem a module configuration `codigo`.
 * Sempre true para `vinicius_admin`.
 *
 * @param {Array} moduleConfigurations
 * @param {{ id?: string, email?: string }} authData
 * @param {string} codigo
 * @param {{ allowNullUserId?: boolean }} [options] — se true, aceita config global (`userId == null`)
 */
export function hasModuleConfiguration(
  moduleConfigurations,
  authData,
  codigo,
  { allowNullUserId = false } = {}
) {
  if (isViniciusAdmin(authData)) return true;
  if (!authData?.id || !codigo) return false;

  return !!moduleConfigurations?.some(
    (m) =>
      m.codigo === codigo &&
      (m.userId === authData.id || (allowNullUserId && m.userId == null))
  );
}
